import { Component, OnInit, Input } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { APPSTORE, DOWNLOADAPP, UserService } from '@app/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { GoogleAnalyticsService } from 'ngx-google-analytics';

@Component({
  selector: 'app-popup',
  templateUrl: './pop-up.component.html',
  styleUrls: ['./pop-up.component.scss'],
})
export class PopUpComponent implements OnInit {
  @Input() sport: string = ''; // Receive the sport from the parent component
  @Input() page: string = ''; // New Input for the page identifier
  topUsers: any[] = [];
  loginForm: FormGroup; // The form for capturing email and user info
  isMobile: boolean = false; // Flag to check if user is on mobile

  constructor(
    private userService: UserService,
    private _builder: FormBuilder,
    private gaService: GoogleAnalyticsService // Inject Google Analytics Service
  ) {
    this.loginForm = this._builder.group({
      email: [''],
      userId: [''],
      priceId: [''],
    });
  }

  ngOnInit() {
    this.isMobile = this.isMobileDevice(); // Detect if the user is on a mobile device
    this.getTopUsers();

    // Delay opening the popup by 3 seconds (3000 ms)
    if (!sessionStorage?.getItem('modalOpen')) {
      setTimeout(() => {
        this.openPopup();
      }, 3000);
    }

    // Only start the countdown if not on mobile
    if (!this.isMobile) {
      this.startCountdown(); // Initiate the countdown on page load
    }

    // Track that the popup was shown, including the page identifier
    this.gaService.event(
      'popup_displayed',
      'subscription_popup',
      `Popup shown on page: ${this.page}`
    );
  }

  private isMobileDevice(): boolean {
    return /Mobi|Android/i.test(navigator.userAgent);
  }

  async getTopUsers() {
    try {
      let params = new HttpParams().set('sport', this.sport).set('limit', '3');
      const res = await this.userService.topUsers(params);
      this.topUsers = res.data.slice(0, 3); // Get top 3 users
    } catch (error) {
      console.error('Error fetching top users:', error);
    }
  }

  startCountdown() {
    const countdownElement = document.getElementById('countdown');
    let timeLeft = 5 * 60; // Set countdown time in seconds (5 minutes)

    const interval = setInterval(() => {
      const minutes = Math.floor(timeLeft / 60);
      const seconds = timeLeft % 60;

      if (countdownElement) {
        countdownElement.innerHTML = `${minutes}:${seconds < 10 ? '0' : ''
          }${seconds}`;
      }

      timeLeft--;

      if (timeLeft < 0) {
        clearInterval(interval); // Stop the countdown once it hits 0
      }
    }, 1000); // Update every second
  }

  startFreeTrial() {
    // Redirect the user to the subscription page
    if(!this.isMobile){
      this.userService.makePayment();
    }else{
      location.href = DOWNLOADAPP; 
    }

    // Track when the free trial button is clicked, including the page identifier
    this.gaService.event(
      'start_free_trial_clicked',
      'subscription_popup',
      `Free Trial Click on page: ${this.page}`
    );
  }


  openPopup() {
    // Check the subscription status before showing the popup
    this.userService.subscribed.subscribe((subscribed) => {
      if (!subscribed) {
        const modal = document.getElementById('trialPopup');
        if (modal) {
          modal.style.display = 'block';
          document.body.classList.add('modal-open');
          document.documentElement.classList.add('modal-open'); // Lock both html and body scrolling
          sessionStorage?.setItem('modalOpen', 'true');
        }
      }
    });
  }

  closePopup(action: string = 'X') {
    const modal = document.getElementById('trialPopup');
    if (modal) {
      modal.style.display = 'none';
      document.body.classList.remove('modal-open');
      document.documentElement.classList.remove('modal-open'); // Unlock both html and body scrolling
    }

    // Track when the popup is closed, including the page identifier
    this.gaService.event(
      'popup_closed',
      'subscription_popup',
      `Popup closed by: ${action} on page: ${this.page}`
    );
  }
}
